import axios from 'axios';

export const malimaxOneApi = axios.create({
    baseURL: `${process.env.REACT_APP_BACKEND!}api/malimax-one`,
    headers: {
        'Content-Type': 'application/json'
    }
})